import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import { CommitmentStatusBadge } from 'components/StatusBadge/StatusBadge';
// utils
import classnames from 'classnames/bind';

// regional date handling
import { connect } from 'react-redux';
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUser } from 'utils/regionalDateHelper';
// styles
import styles from './CommitmentRow.module.scss';

const cn = classnames.bind(styles);

const CommitmentRow = ({
  commitment: { loading, arrive_at, head_count, status },
  onClick,
  isSelected = false,
  countryCode,
}) => (
  <div
    onClick={status === 'pending' ? onClick : undefined}
    className={cn('row-body', { selected: isSelected, disabled: status !== 'pending' })}
  >
    <div className={cn('column', 'semibold')}>
      {isSelected && <i className={cn('fa fa-checkbox-marked-circle', 'icon')} />}
      {loading.name}
      <CommitmentStatusBadge className="mh-10" small status={status} />
    </div>
    <div className={cn('column')}>
      <FormattedMessage id="general.headCount" values={{ head_count: head_count || 'N/A' }} />
    </div>
    <div className={cn('column')}>
      <FormattedMessage
        id="general.arriveAt"
        values={{ arrive: arrive_at ? formatDateForUser(arrive_at, countryCode) : 'N/A' }}
      />
    </div>
  </div>
);

CommitmentRow.propTypes = {
  commitment: T.object.isRequired,
  isSelected: T.bool,
  onClick: T.func.isRequired,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state),
  })
)(CommitmentRow);
